var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 22 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9261 0.60454C11.0986 0.520921 11.3 0.521155 11.4724 0.605174L13.7814 1.7306C15.5749 2.60476 17.5433 3.06748 19.5412 3.0844L21.1733 3.09823C21.5164 3.10113 21.793 3.38009 21.793 3.7232V13.8935C21.793 19.9404 17.6521 25.2072 11.7553 26.6727L11.3497 26.7735C11.251 26.7981 11.1478 26.7981 11.0491 26.7737L10.5985 26.6624C4.69294 25.2034 0.542969 19.9324 0.542969 13.8788V3.68378C0.542969 3.3386 0.822791 3.05878 1.16797 3.05878H2.78238C4.80824 3.05878 6.80735 2.60022 8.62795 1.71806L10.9261 0.60454ZM11.1978 1.86189L9.17301 2.84297C7.18229 3.80755 4.99681 4.30878 2.78238 4.30878H1.79297V13.8788C1.79297 19.3526 5.54606 24.1266 10.8983 25.4489L11.1985 25.5231L11.4538 25.4597C16.7982 24.1315 20.543 19.3612 20.543 13.8935V4.34293L19.5306 4.33436C17.3468 4.31586 15.1948 3.81009 13.2338 2.85424L11.1978 1.86189Z",
    fill: "url(#paint0_linear_4130_19067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.348 7.98125C12.6352 8.17272 12.7128 8.56076 12.5213 8.84797L9.83579 12.8763H13.668C13.8985 12.8763 14.1103 13.0031 14.219 13.2064C14.3278 13.4096 14.3159 13.6562 14.188 13.848L10.8547 18.848C10.6632 19.1352 10.2752 19.2128 9.98795 19.0213C9.70074 18.8298 9.62314 18.4418 9.81461 18.1546L12.5001 14.1263H8.66797C8.43747 14.1263 8.22569 13.9994 8.11692 13.7962C8.00816 13.593 8.02008 13.3464 8.14794 13.1546L11.4813 8.15459C11.6727 7.86739 12.0608 7.78978 12.348 7.98125Z",
    fill: "url(#paint1_linear_4130_19067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4130_19067",
    x1: 1.26946,
    y1: -4.61426,
    x2: 26.6121,
    y2: -3.07396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182684,
    stopColor: "#88A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CDFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_19067",
    x1: 1.26946,
    y1: -4.61426,
    x2: 26.6121,
    y2: -3.07396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.182684,
    stopColor: "#88A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9CDFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTeam);
export default __webpack_public_path__ + "static/media/blue_team.2c78a21ebdb438fbeec50d62fa27d1fd.svg";
export { ForwardRef as ReactComponent };